import { getMessages } from '../../../../../../store/constants';

export const COPIED_SNACKBAR_TEXT = getMessages().getText('card_form_getlink_copied');
export const SNACKBAR_ID_AFFILIATE_LINK_COPIED = 'SNACKBAR_ID_AFFILIATE_LINK_COPIED';
